<template>
  <div>
    <navbar :windowPositions="windowPositions"/>
    <Sliderrtl />
    <Aboutrtl />
    <Featurertl />
    <Workrtl />
    <Screenshotsrtl />
    <Teamrtl />
    <Packagertl />
    <Testimonialrtl />
    <FAQrtl />
    <Blogrtl />
    <DownloadRTL />
    <Footerrtl />
    <Subscribertl />
    <Copyrightrtl />
  </div>
</template>
<script>
import navbar from "@/rtl/components/navbar.vue"
import Sliderrtl from "@/rtl/components/slider.vue";
import Aboutrtl from "@/rtl/components/about.vue";
import Featurertl from "@/rtl/components/feature.vue";
import Workrtl from "@/rtl/components/work.vue";
import Screenshotsrtl from "@/rtl/components/screenshots.vue";
import Teamrtl from "@/rtl/components/team.vue";
import Packagertl from "@/rtl/components/package.vue";
import Testimonialrtl from "@/rtl/components/testimonial.vue";
import FAQrtl from "@/rtl/components/faq.vue";
import Downloadrtl from "@/rtl/components/download.vue";
import Footerrtl from "@/rtl/components/footer.vue";
import Subscribertl from "@/rtl/components/subscribe.vue";
import Copyrightrtl from "@/rtl/components/copy_right.vue";
import Blogrtl from "@/rtl/components/blog.vue";
export default {
  name: "Index",
  data() {
    return {
      screenshotPosition: 0,
      windowPositions: {
        sliderPosition: 0,
        aboutPosition: 0,
        featurePosition: 0,
        workPosition: 0,
        screenshotsPosition: 0,
        teamPosition: 0,
        packagePosition: 0,
        testimonialPosition: 0,
        faqPosition: 0,
        downloadPosition: 0,
        footerPosition: 0,
        subscribePosition: 0,
        copyrightPosition: 0,
        blogPosition: 0,
      },
    };
  },
  mounted: function () {
    document.body.classList.remove("inner-page");
  },
  components: {
    navbar,
    Sliderrtl,
    Aboutrtl,
    Featurertl,
    Workrtl,
    Screenshotsrtl,
    Teamrtl,
    Packagertl,
    Blogrtl,
    Testimonialrtl,
    FAQrtl,
    Downloadrtl,
    Footerrtl,
    Subscribertl,
    Copyrightrtl,
  },
};
</script>
